export const strFixUri = (uri: string): string => {
 if (uri.length > 1) {
  if (uri[uri.length - 1] === '/')
   return uri.substring(0, uri.length - 1);
 }
 return uri;
}